import {axiosInstance} from "@/app/api";
import {onGetTableResponse} from "@/libs/helper";

const onGetReportData = async (url: string, body: any): Promise<any> => {
  return await axiosInstance()
    .post(url, body)
    .then((response: any) => {
      if (response?.data?.status === "success") {
        const neoresponse: NeoResponse<any> = response.data;
        var endPointData = neoresponse?.data?.reportData;

        const rows = endPointData.map((row: any) => ({
          ...row,
          id: row.userId
        }));
        return {
          columns: neoresponse?.data?.columns,
          headerData: neoresponse?.data?.timeData
            ? neoresponse?.data?.timeData
            : [],
          statistics: neoresponse?.data?.statistics,
          rows: rows,
          meta: neoresponse?.meta
        } as TableResponse<any>;
      }
      return onGetTableResponse();
    })
    .catch((error: any) => {
      return onGetTableResponse();
    });
};
const onGetMethodReportData = async (url: string): Promise<any> => {
  return await axiosInstance()
    .get(url)
    .then((response: any) => {
      if (response?.data?.status === "success") {
        const neoresponse: NeoResponse<any> = response.data;
        var endPointData = neoresponse?.data?.reportData;

        const rows = endPointData.map((row: any) => ({
          ...row,
          id: row.userId
        }));
        return {
          columns: neoresponse?.data?.columns,
          headerData: neoresponse?.data?.timeData
            ? neoresponse?.data?.timeData
            : [],
          statistics: neoresponse?.data?.statistics,
          rows: rows,
          meta: neoresponse?.meta
        } as TableResponse<any>;
      }
      return onGetTableResponse();
    })
    .catch((error: any) => {
      return onGetTableResponse();
    });
};

const onGetFuelReportData = async (
  url: string,
  requestdata: any
): Promise<any> => {
  return await axiosInstance()
    .post(url, requestdata)
    .then((response: any) => {
      return response;
    })
    .catch((error: any) => {
      throw error;
    });
};

const onGetFuelSummary = async (requestdata: any): Promise<any> => {
  return await axiosInstance()
    .post("/api/reports/fuel/summary", requestdata)
    .then((response: any) => {
      return response;
    })
    .catch((error: any) => {
      throw error;
    });
};

export const reortsService = {
  onGetReportData,
  onGetMethodReportData,
  onGetFuelReportData,
  onGetFuelSummary
};
